export default __webpack_public_path__ + "static/media/bubbles.8beba9fa.svg";